import React, { useCallback, useState } from 'react';
import './App.css';
import './components/ui.css';

import Header from './components/Header';
import Hero from './components/Hero';
import Services from './components/Services';
import CityHighlights from './components/CityHighlights';
import Footer from './components/Footer';
import RolePicker from './components/RolePicker';
import Loading from './components/Loading';

import useHashRoute from './utils/useHashRoute';
import OwnerPage from './pages/OwnerPage';
import CustomerPage from './pages/CustomerPage';
import { detectCityLocation } from './utils/location';

export default function App() {
  const { route, navigate, isLoading } = useHashRoute();
  const [location, setLocation] = useState(null);
  const [isDetectingLocation, setIsDetectingLocation] = useState(false);
  const [locationError, setLocationError] = useState(null);

  const onPick = (role) => {
    navigate(role === 'owner' ? '/owner' : '/customer');
  };

  const detectLocation = useCallback(async () => {
    setIsDetectingLocation(true);
    setLocationError(null);

    try {
      const detected = await detectCityLocation({ language: navigator.language });
      setLocation({
        name: detected.name,
        lat: detected.lat,
        lon: detected.lon,
        address: detected.address,
        postalCode: detected.postalCode,
        source: detected.source
      });
    } catch (e) {
      console.error('Location detection failed:', e);
      setLocationError('Unable to detect location');
      setLocation({
        name: 'Location Unavailable',
        lat: 0,
        lon: 0,
        address: 'Enable location access for better results',
        postalCode: '',
        source: 'none'
      });
    } finally {
      setIsDetectingLocation(false);
    }
  }, []);

  return (
    <div className="app">
      <Header
        location={location}
        locationError={locationError}
        onDetectLocation={detectLocation}
        isDetectingLocation={isDetectingLocation}
      />
      <Loading show={isLoading} />

      <main>
        {route === '/owner' ? (
          <OwnerPage />
        ) : route === '/customer' ? (
          <CustomerPage />
        ) : (
          <>
            <Hero />
            <Services />
            <CityHighlights
              location={location}
              onDetectLocation={detectLocation}
              isDetecting={isDetectingLocation}
            />
            <RolePicker onPick={onPick} />
          </>
        )}
      </main>

      <Footer />
    </div>
  );
}
